import type { InspectorProps } from "../../lib/inspector";
import { cn } from "../../lib/utils";
import {
  TeaserGrid,
  type TeaserItem,
} from "../../patterns/teaser-grid/teaser-grid";

export type DivisionItem = TeaserItem;

export type DivisionsInspectorProps = InspectorProps<"container" | "divisions">;

export type DivisionsProps = {
  sys?: { id: string };
  divisions: readonly DivisionItem[];
  ariaLabel?: string;
  className?: string;
  inspectorProps?: DivisionsInspectorProps;
};

export function Divisions(props: Readonly<DivisionsProps>) {
  if (props.divisions.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label={props.ariaLabel ?? "SCOTT divisions"}
      className={cn("component-divisions w-full", props.className)}
      data-testid="divisions"
      {...props.inspectorProps?.container}
    >
      <TeaserGrid
        aspectRatio="2:3"
        gap="none"
        inspectorProps={{ container: props.inspectorProps?.divisions }}
        items={props.divisions}
        mobileAspectRatio="1:1"
        mobileColumnCount={props.divisions.length % 2 === 0 ? 2 : 1}
        testId="divisions-grid"
      />
    </nav>
  );
}
